import * as React from 'react'
import Image from 'next/image'
import { styled } from '@mui/system'
import { Box, Container } from '@mui/material'
import { motion } from 'framer-motion'
import { fadeUp, fadeUpDelay } from '../../src/animationVariants'
import JeffImg from '../../public/images/founders/avatar-jeff.jpeg'
import ConstantineImg from '../../public/images/founders/avatar-constantine.jpeg'
import IgorImg from '../../public/images/founders/avatar-igor.jpeg'

const GridContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column'
  }
}))

const GridItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '29%',
  padding: '0 60px',
  '&:nth-of-type(2)': {
    borderLeft: '1px dashed #d7d7d7',
    borderRight: '1px dashed #d7d7d7'
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    marginBottom: 50,
    padding: '0 10px',
    textAlign: 'center',
    '&:nth-of-type(2)': {
      border: 'none'
    }
  }
}))

const Title = styled(Box)(({ theme }) => ({
  fontSize: 24,
  margin: 0,
  textAlign: 'center',
  fontWeight: 900
}))

const SubTitle = styled(Box)(({ theme }) => ({
  fontSize: '1.125rem',
  textAlign: 'center',
  letterSpacing: '0.01em',
  fontWeight: 600,
  marginBottom: 30,
  [theme.breakpoints.down('md')]: {
    marginBottom: 0
  }
}))

const Description = styled(Box)(({ theme }) => ({
  fontSize: 16,
  lineHeight: 1.25,
  fontWeight: 500
}))

const ImageWrap = styled(Box)(({ theme }) => ({
  margin: '0 auto 20px',
  '& img': {
    borderRadius: '50%'
  }
}))

export default function Founders () {
  return (
    <>
      <Box
        component='h2'
        sx={{
          textAlign: 'center',
          margin: { xs: '80px 0 60px', md: '145px 0 120px' },
          fontSize: { xs: '2.25rem', md: '3.4375rem' },
          fontWeight: 900
        }}
      >Founders
      </Box>
      <Container maxWidth='xl' sx={{ mb: 20 }}>
        <GridContainer>
          <GridItem item xs={12} sm={4}>
            <ImageWrap>
              <motion.div
                variants={fadeUp}
                initial={{ opacity: 0, y: 50 }}
                whileInView='onscreen'
                viewport={{ once: false }}
              >
                <Image
                  src={JeffImg}
                  width={225} height={225}
                  alt='Jeff Halevy'
                />
              </motion.div>
            </ImageWrap>
            <motion.div
              variants={fadeUpDelay}
              initial={{ opacity: 0, y: 50 }}
              whileInView='onscreen'
              viewport={{ once: false }}
            >
              <Title component='h3'>Jeff Halevy</Title>
              <SubTitle>CEO & Cofounder</SubTitle>
              <Description>
                <p>Inc. 5000-winner and multi-business/exit 15- year veteran of the fitness industry</p>
                <p>Former TODAY Show Correspondent (NBC) and Host of internationally-syndicated TV show Workout From Within with Jeff Halevy</p>
                <p>Creator of lauded technology-based fitness program for Michelle Obama’s childhood obesity campaign, Let’s Move!</p>
              </Description>
            </motion.div>
          </GridItem>
          <GridItem item xs={12} sm={4}>
            <ImageWrap>
              <motion.div
                variants={fadeUp}
                initial={{ opacity: 0, y: 50 }}
                whileInView='onscreen'
                viewport={{ once: false }}
              >
                <Image
                  src={ConstantineImg}
                  width={225} height={225}
                  alt='Constantine Goltsev'
                />
              </motion.div>
            </ImageWrap>
            <motion.div
              variants={fadeUpDelay}
              initial={{ opacity: 0, y: 50 }}
              whileInView='onscreen'
              viewport={{ once: false }}
            >
              <Title component='h3'>Constantine Goltsev</Title>
              <SubTitle>CTO & Cofounder</SubTitle>
              <Description>
                <p>Serial technologist entrepreneur with multiple exits and 20+ years of success in technology and product delivery</p>
                <p>Founder & CEO of AdoTube, one of the first video ad networks</p>
                <p>Founder & Chairman of Neuromation.io, a premier AI development platform (clients include Johnson&Johnson, Panasonic, LG)</p>
              </Description>
            </motion.div>
          </GridItem>
          <GridItem item xs={12} sm={4}>
            <ImageWrap>
              <motion.div
                variants={fadeUp}
                initial={{ opacity: 0, y: 50 }}
                whileInView='onscreen'
                viewport={{ once: false }}
              >
                <Image
                  src={IgorImg}
                  width={225} height={225}
                  alt='Igor Magazinik'
                />
              </motion.div>
            </ImageWrap>
            <motion.div
              variants={fadeUpDelay}
              initial={{ opacity: 0, y: 50 }}
              whileInView='onscreen'
              viewport={{ once: false }}
            >
              <Title component='h3'>Igor Magazinik</Title>
              <SubTitle>Cofounder & Chairman</SubTitle>
              <Description>Cofounder & CTO of Juno and Viber.</Description>
            </motion.div>
          </GridItem>
        </GridContainer>
      </Container>
    </>
  )
}
